import { Node } from './tree-node.model';
/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface EvidenceInstance {
  /**
   * The unique identifier of this evidence instance
   */
  evidence_instance_id?: string;
  /**
   * The evidence id of this evidence
   */
  evidence_id?: string;
  /**
   * The type of this specific evidence instance
   */
  evidence_type?: EvidenceTypeEnum;
  /**
   * The name of this specific evidence
   */
  evidence_name?: string;

  evidence_display_name?: string;
  /**
   * The service this evidence was collected by
   */
  evidence_service_id?: string;
  evidence_service_instance_id?: string;

  evidence_originated_by_instance_id?: string;
  /**
   * The display name related with the service that collected this evidence
   */
  evidence_service_display_name?: string;
  /**
   * The time this evidence was collected
   */
  evidence_collection_timestamp?: Date;
  /**
   * The time when the evidence was created
   */
  evidence_creation_time?: string;
  /**
   * Whether this evidence is applicable for the customer
   */
  evidence_is_applicable?: boolean;
    /**
   * Whether this evidence has been opened before
   */
  evidence_is_seen?: boolean;
  /**
   * Whether this evidence is customized
   */
  evidence_is_custom?: boolean;
  evidence_url?: string;
  evidence_preview?: any;
  evidence_empty_state?: string;
  evidence_alert_level?: AnalysisRuleAlertLevelEnum;
  evidence_alert_level_gap_rules_only?: AnalysisRuleAlertLevelEnum;
  /**
   * items count in evidence full data
   */
  evidence_items_count?: number;
  /**
   * evidence executed api request
   */
  evidence_api_query?: string[];
  /**
   * evidence time frame, in case of a log type
   */
  evidence_time_frame?: string;
  /**
   * A help phrase describing the purpose of this evidence
   */
  evidence_help?: string;
  evidence_last_modified_by?: string;
  evidence_column_help?: ColumnHelp[];
  evidence_analysis_results?: EvidenceGap[];
  evidence_gap_message?: string;
  evidence_tip?: string;
  evidence_is_beta?: boolean;
  snapshot_id?: string;
  evidence_is_uar?: boolean;
  evidence_is_sot?: boolean;
  evidence_source_screenshots_data?: string[];
  evidence_status?: { [key: string]: EvidenceStatus; default: EvidenceStatus };
  last_instances_per_service_instance?: EvidenceAccountInstance[];
  /** Evidence Filters */
    /**
   * This property is going to be deprecated and will be removed in future versions.
   * Use `evidence view v2` instead.
   */
  evidence_views?: EvidenceViewDictionary;
    /**
   * This property is going to be deprecated and will be removed in future versions.
   * Use `evidence view v2` instead.
   */
  evidence_views_map?: EvidenceViewMapDictionary;
  evidence_column_metadata?: EvidenceMetadataDictionary;
  evidence_best_practice?: string;
  evidence_collection_frequency?: 'always' | 'never' | 'weekly';
  preview_exists?: boolean;
  evidence_iceberg_exists?: boolean;
  evidence_processing_state?: EvidenceProcessingState;
  evidence_entity_type?: EvidenceEntityType;
  evidence_filter_aql?: Node<any, any>;
  evidence_filter_aql_ext?: AqlExt;
    /**
   * The parent evidence id of this instance
   */
  evidence_parent_id?: string;
  evidence_excluded_instances?: string[];
  ai_naming_suggestions?: string[];
  evidence_rule_scope?: string[];
  evidence_summary?: string;
  ai_summary_suggestion?: string;
  merged_evidence_metadata?: MergeEvidenceMetadata;
  merged_items_count_by_source?: ItemsBreakdownModel;
}

export enum EvidenceEntityType {
  View = 'EVIDENCE_VIEW_TYPE',
  Evidence = 'EVIDENCE_TYPE'
}

export enum EvidenceProcessingState {
  SuccessEmpty = 'success_empty',
  SuccessDataExists = 'success_data_exists',
  Collected = 'collected',
  ProcessFailed  = 'process_failed',
  InProgress = 'in_progress'
}

export interface MergeEvidenceMetadata {
  left_evidence: MergedEvidenceSideMetadata,
  right_evidence: MergedEvidenceSideMetadata,
}

export interface MergedEvidenceSideMetadata {
  evidence_id: string;
  join_on_column: string;
  service_id: string;
  service_instance_id: string;
  evidence?: EvidenceInstance;
}

export interface EvidenceGap {
  rule_id: string | 'LEGACY_GAP_RESULT';
  alert_level: AnalysisRuleAlertLevelEnum;
  violated_rows: number[];
}

export enum AnalysisRuleAlertLevelEnum {
  GAP = 50,
  WARN = 30,
  OK = 10,
  NOT_SET = 5,
}

export interface EvidenceAccountInstance {
  evidence_instance_id?: string;
  evidence_id?: string;
  evidence_name?: string;
  evidence_collection_timestamp?: Date;
  evidence_service_id?: string;
  evidence_service_instance_id?: string;
  evidence_url?: string;
  evidence_items_count?: number;
  evidence_api_query?: string[];
  evidence_time_frame?: string;
  evidence_analysis_results?: EvidenceGap[];
  evidence_gap?: {
    rule_id: string;
    alert_level: AnalysisRuleAlertLevelEnum;
    violated_rows: number[];
  }[];
  evidence_collection_run_id?: string;
  evidence_last_modified_time?: Date;
  evidence_last_modified_by?: string;
}

export interface EvidenceMetadataDictionary {
  [columnId: string]: string[];
}

export interface EvidenceViewDictionary {
  [viewId: string]: EvidenceView;
}

export interface EvidenceViewMapDictionary {
  [context_resource_id: string]: EvidenceViewMap;
}

export interface EvidenceViewMap {
  updated_by?: string;
  updated_time?: string;
  view_id: string;
}

export interface EvidenceFullDataColumnSchema {
  column_name: string;
  column_type: string;
}

export interface EvidenceFullDataQuery {
  aql?: any,
  aql_ext?: AqlExt,
  evidence_instance_ids: string[];
  limit: number;
  offset: number;
  sort_by_column: string;
  sort_by_direction: string;
  sort_by_type?: string;
  search_query?: string;
}

export interface MergeEvidenceDataQuery {
  evidence_instance_ids: string[];
  limit: number;
  offset: number;
  sort_by_column: string;
  sort_by_direction: string;
}

export interface EvidenceFullDataTotalRowsQuery {
  aql: any,
  aql_ext: any,
  evidence_instance_ids: string[];
  search_query: string;
}

export interface EvidenceFullDataFilterSuggestionsQuery {
  column_name: string;
  evidence_instance_ids: string[];
  aql?: any,
  aql_ext?: any,
  offset?: number;
  starts_with?: "string"
}

export interface ItemsBreakdownModel {
  left_only?: number;
  right_only?: number;
  both?: number;
}

export interface EvidenceFullDataQueryResult {
  data: { [key: string]: any[] };
}

export interface EvidenceFullDataFilterSuggestionsResult {
  data: string[];
  total_count: number;
}

/**
 * evidence_id to evidence_instance_id map
 */
export interface EvidenceFrameworkContext {
  latest_instances_per_evidence_id: { [evidence_id: string]: {
    evidence_instance_id: string;
    service_instance_id?: string;
    evidence_iceberg_exists: boolean;
  } };
}

export interface EvidenceInstanceFullData {
  [key: string]: string[];
}

export interface EvidenceStatus {
  evidence_alert_level?: AnalysisRuleAlertLevelEnum;
  evidence_alert_gaps_only?: AnalysisRuleAlertLevelEnum;
  status: EvidenceStatusEnum;
  timestamp?: Date;
  updated_by?: string;
  update_mode?: 'auto' | 'manual';
}

export enum AqlExtManipulationOperator {
  CensorColumn = 'CensorColumn',
  HideColumn = 'HideColumn',
}

export interface AqlManipulation {
  operator_name: AqlExtManipulationOperator;
  column_name: string;
}

export interface AqlExt {
  base?: any;
  filters?: Node<any, any>;
  manipulations: AqlManipulation[];
}

export interface ExtendedFilters extends Node<any, any> {
  aql_ext?: AqlExt;
}

export interface CreateEvidenceView extends EvidenceViewAqlProperties {
  name: string;
}

export interface UpdateEvidenceView extends EvidenceViewAqlProperties {
  id: string;
}

export interface EvidenceViewAqlProperties {
  aql?: Node<any, any>;
  aql_ext?: AqlExt;
}

export interface EvidenceView extends CreateEvidenceView {
  id: string;
  aql_rule?: string;
  created_by?: string;
  upload_time?: Date;
  updated_by?: string;
  updated_time?: Date;
}

export interface EvidenceViewV2AqlProperties {
  filter_aql?: Node<any, any>;
  filter_aql_ext?: AqlExt;
}

export interface EvidenceViewV2 extends EvidenceViewV2AqlProperties {
  view_id: string;
  view_name: string;
  evidence_parent_id: string;
  description: string;
  rule_ids?: string[];
  excluded_service_instance_ids?: string[]
}

export interface BulkUpdateViewsResponse {
  updated_evidence_views: EvidenceViewV2[];
  failed_evidence_views: EvidenceViewV2[];
}

export interface ColumnHelp {
  column_name: string;
  help_note: string;
}

export type EvidenceTypeEnum =
  | 'DOCUMENT'
  | 'LOG'
  | 'LIST'
  | 'CONFIGURATION'
  | 'APP'
  | 'UNKNOWN'
  | 'LINK'
  | 'MANUAL'
  | 'URL'
  | 'TICKET'
  | 'API'
  | 'MERGED'
  | 'BUILDER';
export const EvidenceTypeEnum = {
  DOCUMENT: 'DOCUMENT' as EvidenceTypeEnum,
  LOG: 'LOG' as EvidenceTypeEnum,
  LIST: 'LIST' as EvidenceTypeEnum,
  CONFIGURATION: 'CONFIGURATION' as EvidenceTypeEnum,
  APP: 'APP' as EvidenceTypeEnum,
  UNKNOWN: 'UNKNOWN' as EvidenceTypeEnum,
  LINK: 'LINK' as EvidenceTypeEnum,
  MANUAL: 'MANUAL' as EvidenceTypeEnum,
  URL: 'URL' as EvidenceTypeEnum,
  TICKET: 'TICKET' as EvidenceTypeEnum,
  API: 'API' as EvidenceTypeEnum,
  MERGED: 'MERGED' as EvidenceTypeEnum,
  BUILDER: 'BUILDER' as EvidenceTypeEnum,
};

export enum EvidenceStatusEnum {
  Gap = 'GAP',
  Unset = 'NOT_SET',
  Auditable = 'AUDITABLE',
  New = 'NEW',
}

export interface EvidenceStatusDef {
  status: EvidenceStatusEnum;
  display: string;
  color: string;
  icon: string;
  selector: (status: EvidenceStatusEnum) => boolean;
}

export interface EvidenceLinkEvidenceWithEmailRequest {
  url: string;
  collect_by_user: string;
}

export type EvidenceFilterType = 'aql' | 'manipulation' | 'excludeAccount' | 'includeAnalysisRules';

export const MERGED_COLUMN_SEPARATOR = '___';
export const SOURCE_COLUMN = 'Evidence_Source';
export const SOURCE_COLUMN_DISPLAY_NAME = 'Source';

export function isSourceColumn(columnId: string): boolean {
  return columnId?.toLowerCase() === SOURCE_COLUMN.toLowerCase();
}

export enum MatchingTypesEnum {
  BOTH = 'both',
  LEFT = 'left_only',
  RIGHT = 'right_only'
}

export enum EvidenceRolesEnum {
  FIRST = 'first',
  SECOND = 'second',
}
